import { styled } from '@mui/material/styles';
import { Stack, Container, Typography, Box, Link } from '@mui/material';
import { useEffect, useState } from 'react';

// components
import Page from '../components/Page';
import { LoginForm } from '../sections/authentication/login';
import { Link as RouterLink } from 'react-router-dom';
import { get_crm_logo_favicon } from '../ApiServices';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  },
  backgroundColor: process.env.REACT_APP_BACKGROUND
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 450,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
}));
// ----------------------------------------------------------------------

export default function Login() {
  const [crmLogo, setCrmLogo] = useState(null);
  useEffect(() => {
    const fetchCrmAssets = async () => {
      try {
        const res = await get_crm_logo_favicon();

        if (res?.data?.length) {
          // CRM LOGO
          const logo = res.data.find((item) => item.key === 'crm_logo');
          if (logo?.value) {
            setCrmLogo(logo.value);
          }

          // CRM FAVICON
          // const favicon = res.data.find((item) => item.key === 'website_crm_favicon');

          // if (favicon?.value) {
          //   let link =
          //     document.querySelector("link[rel~='icon']") || document.createElement('link');

          //   link.rel = 'icon';
          //   link.type = 'image/png';
          //   link.href = favicon?.value;

          //   document.head.appendChild(link);
          // }
        }
      } catch (error) {
        console.error('Failed to load CRM assets:', error);
      }
    };

    fetchCrmAssets();
  }, []);
  return (
    <RootStyle title={`Login | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
            {/* {console.log('CRM LOGO:', crmLogo)} */}
            <Box
              component="img"
              // src={process.env.REACT_APP_LOGIN}
              src={crmLogo || process.env.REACT_APP_LOGIN}
              sx={{
                marginLeft: 1,
                width: 200,
                height: 90
              }}
            />

            <Typography sx={{ fontSize: 25, fontFamily: 'poppinsBold' }}>
              Login to your Account
            </Typography>
          </Stack>

          <LoginForm />
          {/* <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{ mt:3, fontSize: 12, fontFamily: 'poppinsRegular' }}
          >
            <span style={{ color: '#4B5563', fontSize: 13, fontFamily: 'poppinsRegular' }}>
              Not Registered Yet?
            </span>
            <Link
              component={RouterLink}
              to="/signup"
              underline="hover"
              sx={{ fontFamily: 'poppinsBold', fontSize: 13, ml: 1 }}
            >
              Create an account
            </Link>
          </Stack> */}
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
